import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import DynamicArticlePage from "../pages/article-dynamic/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/:slug",
    element: <DynamicArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;